import { useTranslation } from 'react-i18next';

export default function Gallery() {
  const { t } = useTranslation();
  
  const images = [
    {
      id: 1,
      url: 'https://static.readdy.ai/image/b9dffa7b6b8fd92109fabc077dd82307/117398e668cc99985d0585cba371aacf.png',
      title: t('gallery.image1Title'),
      description: t('gallery.image1Desc')
    },
    {
      id: 2,
      url: 'https://static.readdy.ai/image/b9dffa7b6b8fd92109fabc077dd82307/96d23cda7a8338127a765a425edf7ec9.png',
      title: t('gallery.image2Title'),
      description: t('gallery.image2Desc')
    },
    {
      id: 3,
      url: 'https://static.readdy.ai/image/b9dffa7b6b8fd92109fabc077dd82307/afc7969e84f388eb3cfa089aad6668d3.png',
      title: t('gallery.image3Title'),
      description: t('gallery.image3Desc')
    },
    {
      id: 4,
      url: 'https://static.readdy.ai/image/b9dffa7b6b8fd92109fabc077dd82307/70479e0b43187b0cde1095808351a6a8.png',
      title: t('gallery.image4Title'),
      description: t('gallery.image4Desc')
    },
    {
      id: 5,
      url: 'https://static.readdy.ai/image/b9dffa7b6b8fd92109fabc077dd82307/ed9d9870b79dc106a8c56fc1b0f0a0c5.png',
      title: t('gallery.image5Title'),
      description: t('gallery.image5Desc')
    },
    {
      id: 6,
      url: 'https://public.readdy.ai/ai/img_res/fdde8cbf6e978b8ff4714e2cab2cb28b.jpg',
      title: t('gallery.image6Title'),
      description: t('gallery.image6Desc')
    }
  ];

  return (
    <section id="gallery" className="py-16 sm:py-24 bg-gradient-to-b from-amber-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block mb-3 sm:mb-4">
            <span className="text-amber-600 font-semibold text-xs sm:text-sm tracking-wider uppercase">{t('gallery.badge')}</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('gallery.title')}
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            {t('gallery.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {images.map((image) => (
            <div
              key={image.id}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer aspect-square"
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-white font-bold text-lg sm:text-xl mb-1 sm:mb-2">{image.title}</h3>
                  <p className="text-amber-100 text-xs sm:text-sm">{image.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center px-2">
          <p className="text-gray-600 mb-4 sm:mb-6 text-base sm:text-lg">{t('gallery.followText')}</p>
          <div className="flex justify-center">
            <a href="https://www.instagram.com/__kahve_molasi__/" target="_blank" rel="nofollow noopener noreferrer" className="w-11 h-11 sm:w-12 sm:h-12 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-white hover:scale-110 transition-transform duration-300 cursor-pointer">
              <i className="ri-instagram-fill text-xl sm:text-2xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
